<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
  <path stroke="#000" d="M3 7v15h18V7H3z" clip-rule="evenodd"/>
  <path stroke="#000" d="M7.5 7V4.5C7.5 3 10 2 12 2s4.5 1 4.5 2.5V7"/>
</svg>
